// B1/B2 (2026-05-15) — API client for the project "logged but not
// invoiced" hours summary. Backend endpoint:
//   GET /api/projects/:projectId/uninvoiced-hours
//
// Response is discriminated by `kind`:
//   - 'hourly'  → every uninvoiced approved/submitted entry, grouped per
//                 calendar month. byMonth[].byRole is always [] and
//                 byMonth[].approval is always null in this mode.
//   - 'overage' → SLA Hour Package project with over-limit allowed.
//                 byMonth[].byRole carries per-role overage attribution and
//                 byMonth[].approval surfaces the PM monthly approval state
//                 as a soft warn (missing / less / ok).
//
// hasZeroRateOverage is true when at least one overage hour in any month
// cannot be billed because the role lacks a ProjectOverageRate (or the
// entry pre-dates Phase 38 and has no role assigned).
//
// Mounted via `projectUninvoicedHoursRoutes` and gated by
// `requireAdminOrProjectMemberByProject`.

import { apiGet } from './client';

export type UninvoicedKind = 'hourly' | 'overage';

export interface UninvoicedRoleBucket {
  roleId: number | null;
  roleName: string | null;
  hours: number;
  hourlyRate: number;
  billing: number;
  hasRate: boolean;
}

export interface UninvoicedApprovalStatus {
  approvedHours: number | null;
  status: 'missing' | 'less' | 'ok';
}

export interface MonthlyUninvoicedBucket {
  period: string;
  hours: number;
  billing: number;
  byRole: UninvoicedRoleBucket[];
  approval: UninvoicedApprovalStatus | null;
}

export interface ProjectUninvoicedHoursSummary {
  kind: UninvoicedKind;
  totalHours: number;
  totalBilling: number;
  currency: string;
  hasZeroRateOverage: boolean;
  byMonth: MonthlyUninvoicedBucket[];
}

export function fetchProjectUninvoicedHours(projectId: number) {
  return apiGet<{ data: ProjectUninvoicedHoursSummary }>(
    `/projects/${projectId}/uninvoiced-hours`,
  );
}
